import { getWhisper } from './whisperApi';
import { whenDebug } from './debugUtils';
/**
 * Creates a reporter instance with a prefix for error tracking
 * @param prefix - The prefix to prepend to all messages (e.g., '[my-module]')
 * @returns A reporter object with captureError and captureMessage methods
 */
export const createReporter = prefix => {
  return {
    captureError: (message, error, options) => {
      var _whisper$captureError;
      const whisper = getWhisper();
      const prefixedMessage = `${prefix} ${message}`;
      whisper === null || whisper === void 0 || (_whisper$captureError = whisper.captureError) === null || _whisper$captureError === void 0 || _whisper$captureError.call(whisper, prefixedMessage, error, options);
      // eslint-disable-next-line no-console
      whenDebug(() => console.error(prefixedMessage, error));
    },
    captureMessage: (message, options) => {
      var _whisper$captureMessa;
      const whisper = getWhisper();
      const prefixedMessage = `${prefix} ${message}`;
      whisper === null || whisper === void 0 || (_whisper$captureMessa = whisper.captureMessage) === null || _whisper$captureMessa === void 0 || _whisper$captureMessa.call(whisper, prefixedMessage, options);
      // eslint-disable-next-line no-console
      whenDebug(() => console.error(prefixedMessage));
    }
  };
};